
export function PaymentCancel() {
    return (
        <div className="content-inner main-block content-wide">
            <div className="narrow">
                <h1>
                    Payment cancelled
                </h1>
                <p>
                    Your booking has not been confirmed.
                    Please try again if you would like to continue.
                </p>
            </div>
        </div>
    );
}